import { useContext, useMemo } from 'react';
import appNavItemTypeCheckers from '../../../../../../types/appNavItemTypeCheckers';
import useEntity from '../../../../../../hooks/useEntity';
import { V3AppsContext } from '../../../../../../contextProviders/SplashScreenProviders/UserAndAccountProviders/V3AppsProvider';

const useMappedViewMetaData = (
  mappedView: UserManagement.EngagementContentMapping | undefined,
) => {
  const { entity, app } = useEntity(
    mappedView
      ? {
          entityId: mappedView.entityId,
          entityAppId: mappedView.entityAppId,
        }
      : {},
  );
  const { allProductApps, allProducts } = useContext(V3AppsContext);

  const navItemMappedTo = useMemo(() => {
    if (!mappedView) {
      return undefined;
    }

    for (const p of allProductApps) {
      for (const section of p.navigationSettings.sections) {
        for (const item of section.items) {
          if (appNavItemTypeCheckers.isMappedEntityView(item)) {
            if (
              item.entityId === mappedView.entityId &&
              item.entityAppId === mappedView.entityAppId
            ) {
              return {
                app: p,
                item,
                product: allProducts.find((p2) => p2.appIds.includes(p.id)),
              };
            }
          }
        }
      }
    }
  }, [allProductApps, allProducts, mappedView]);

  const metaData = useMemo(() => {
    if (!entity || !app || !navItemMappedTo || !navItemMappedTo.product) {
      return undefined;
    }

    return {
      entity,
      entityApp: app,
      app: navItemMappedTo.app,
      product: navItemMappedTo.product,
      navItem: navItemMappedTo.item,
    };
  }, [app, entity, navItemMappedTo]);

  return metaData;
};

export default useMappedViewMetaData;
